/**
 * @generated SignedSource<<eac6514e594c2e6e8979a745c7d9215c>>
 * @relayHash c40005688009ad578d2262abe92dfdd6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 42292b23d4d61a2a7e987006bd56b1edc64641483aaf6e59202fb8e13a1830da

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { PlaybookLogsQuery } from './PlaybookLogsQuery.graphql';

const node: PreloadableConcreteRequest<PlaybookLogsQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "42292b23d4d61a2a7e987006bd56b1edc64641483aaf6e59202fb8e13a1830da",
    "metadata": {},
    "name": "PlaybookLogsQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
